import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import ProcessBar from "../../components/ProcessBar/ProcessBar";
import BrandPage from "../BrandPage/BrandPage";
import ModelPage from "../ModelPage/ModelPage";
import StoragePage from "../StoragePage/StoragePage";
import OfferUnsuccess from "../OfferUnsuccess/OfferUnsuccess";
import SendInfo from "../SendInfo/SendInfo";
import ScheduleVisit from "../ScheduleVisit/ScheduleVisit";
import ConditionsContainer from "../ConditionsContainer/ConditionsContainer";
import UserData from "../UserData/UserData";
import DeliveryMethod from "../DeliveryMethod/DeliveryMethod";
import OfferByDays from "../OfferByDays/OfferByDays";
import NewSummary from "../NewSummary/NewSummary";
import BatteryLevel from "../BatteryLevel/BatteryLevel";
import axios from "axios";
import "./styles.css";

function InitialPage() {
  const [grade, setGrade] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedStorage, setSelectedStorage] = useState("");
  const [goodCondition, setGoodCondition] = useState(null);
  const [buttonsCondition, setButtonsCondition] = useState(null);
  const [exteriorCondition, setExteriorCondition] = useState(null);
  const [screenCondition, setScreenCondition] = useState(null);
  const [percentage, setPercentage] = useState(12);
  const [currentPage, setCurrentPage] = useState("brand");
  const [showScheduleVisit, setShowScheduleVisit] = useState(false);
  const [scheduleInfo, setScheduleInfo] = useState(null);
  const [sendInfoData, setSendInfoData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [deliveryMethod, setDeliveryMethod] = useState(null);
  const [batteryLevelSelected, setBatteryLevelSelected] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [id, setId] = useState("");

  const handleBrandSelect = (brand) => {
    setSelectedBrand(brand);
    setPercentage(25);
    setCurrentPage("model");
    handleCreateInfo(brand);
  };

  const handleModelSelect = (model) => {
    setSelectedModel(model);
    setPercentage(37);
    setCurrentPage("storage");
  };

  const handleStorageSelect = (storage) => {
    setSelectedStorage(storage);
    setPercentage(50);
    if (selectedBrand === "Apple") {
      setCurrentPage("batteryLevel");
    } else {
      setCurrentPage("conditions");
    }
  };

  const handleConditionsSelect = (
    grade,
    buttonsCondition,
    exteriorCondition,
    screenCondition
  ) => {
    setGoodCondition(grade !== null);
    setButtonsCondition(buttonsCondition);
    setExteriorCondition(exteriorCondition);
    setScreenCondition(screenCondition);
    setGrade(grade);
    setPercentage(62);
    if (grade !== null) {
      setCurrentPage("userData");
    } else {
      setCurrentPage("offerUnsuccess");
    }
  };

  const handleUserDataSubmit = (data) => {
    setUserData(data);
    setPercentage(75);
    setCurrentPage("offerByDays");
  };

  const handleDeliveryMethodSubmit = (method) => {
    setDeliveryMethod(method);
    setPercentage(87);
    if (method === "domicilio") {
      setCurrentPage("scheduleVisit");
    } else if (method === "punto de venta") {
      setCurrentPage("sendInfo");
    }
  };

  const handleBatteryLevelSelected = (batteryLevel) => {
    setBatteryLevelSelected(batteryLevel);
    setPercentage(52);
    setCurrentPage("conditions");
  };

  const handleSendInfoContinue = (info) => {
    setPercentage(95);
    setSendInfoData(info);
    if (info.localOption) {
      setScheduleInfo(info);
      setCurrentPage("scheduleVisit");
    } else if (info.homeOption) {
      setCurrentPage("summary");
    }
  };

  const handleSchedule = (info) => {
    setScheduleInfo(info);
    setCurrentPage("newSummary");
    setShowScheduleVisit(false);
    setPercentage(100);
  };

  const handleOfferSelect = (paymentPeriod, price, product_id) => {
    setSelectedOffer({ paymentPeriod, price, product_id });
    setCurrentPage("deliveryMethod");
  };
  const handleCreateInfo = (brand) => {
    const body = {
      brand: brand,
    };

    axios
      .post(
        "https://api.quieromac.com/retomas/inventory/celucambio/save_abandoned",
        body
      )
      .then((response) => {
        console.log("Progreso guardado:", response.data);
        setId(response.data.id);
      })
      .catch((error) => {
        console.error("Error al guardar el progreso:", error);
      });
  };
  useEffect(() => {
    handleUpdateInfo();
  }, [
    selectedModel,
    selectedStorage,
    userData,
    grade,
    buttonsCondition,
    exteriorCondition,
    screenCondition,
    selectedOffer,
    scheduleInfo,
    sendInfoData,
    deliveryMethod,
    batteryLevelSelected
  ]);
  const handleUpdateInfo = () => {
    const body = {
      email: userData?.email,
      phone: userData?.phone,
      brand: selectedBrand,
      model_id: selectedModel?.id,
      storage_id: selectedStorage?.storage_id,
      final_grade: grade,
      turns_on_and_buttons_ok: buttonsCondition,
      exterior_is_ok: exteriorCondition,
      cameras_and_touchscreen: screenCondition,
      product_id: selectedOffer?.price,
      address: scheduleInfo?.address,
      address2: scheduleInfo?.address2,
      payment_period: selectedOffer?.paymentPeriod,
      schedule_date: scheduleInfo?.date,
      schedule_time: `${scheduleInfo?.start_time} / ${scheduleInfo?.end_time}`,
      schedule_id: scheduleInfo?.scheduleId,
      payment_period: selectedOffer?.paymentPeriod,
      delivery: deliveryMethod === "domicilio",
      battery_level: batteryLevelSelected,
      id: id,
    };

    axios
      .put(
        "https://api.quieromac.com/retomas/inventory/celucambio/save_abandoned",
        body
      )
      .then((response) => {
        console.log("Progreso guardado:", response.data);
      })
      .catch((error) => {
        console.error("Error al guardar el progreso:", error);
      });
  };
  const handleBack = () => {
    if (currentPage === "scheduleVisit") {
      setCurrentPage("deliveryMethod");
      setPercentage(75);
    } else if (currentPage === "sendInfo") {
      setCurrentPage("deliveryMethod");
      setPercentage(75);
    } else if (currentPage === "deliveryMethod") {
      setCurrentPage("offerByDays");
      setPercentage(62);
    } else if (currentPage === "userData") {
      setCurrentPage("conditions");
      setPercentage(50);
    } else if (currentPage === "model") {
      setSelectedBrand("");
      setPercentage(12);
      setCurrentPage("brand");
    } else if (currentPage === "storage") {
      setSelectedModel("");
      setPercentage(25);
      setCurrentPage("model");
    } else if (currentPage === "conditions") {
      if (selectedBrand === "Apple") {
        setBatteryLevelSelected("");
        setPercentage(37);
        setCurrentPage("batteryLevel");
      } else {
        setSelectedStorage("");
        setPercentage(37);
        setCurrentPage("storage");
      }
    } else if (currentPage === "batteryLevel") {
      setSelectedStorage("");
      setPercentage(37);
      setCurrentPage("storage");
    } else if (currentPage === "offerUnsuccess") {
      setCurrentPage("conditions");
      setPercentage(75);
    } else if (currentPage === "offerByDays") {
      setCurrentPage("userData");
      setPercentage(87);
    }
  };

  return (
    <div>
      <Header
        brand={selectedBrand}
        model={selectedModel}
        storage={selectedStorage}
        goodCondition={goodCondition}
        buttonsCondition={buttonsCondition}
        exteriorCondition={exteriorCondition}
        screenCondition={screenCondition}
        grade={grade}
        // price={price}
        sendInfoData={sendInfoData}
      />
      {currentPage !== "sendInfo" &&
        !showScheduleVisit &&
        currentPage !== "summary" && <ProcessBar percentage={percentage} />}
      <div className="container pageSize">
        {currentPage === "brand" && (
          <BrandPage onBrandSelect={handleBrandSelect} />
        )}
        {currentPage === "model" && (
          <ModelPage
            onModelSelect={handleModelSelect}
            onBack={handleBack}
            brand={selectedBrand}
          />
        )}
        {currentPage === "storage" && (
          <StoragePage
            onStorageSelect={handleStorageSelect}
            onBack={handleBack}
            brand={selectedBrand}
            model={selectedModel}
          />
        )}
        {currentPage === "batteryLevel" && (
          <BatteryLevel
            onBack={handleBack}
            onSelect={handleBatteryLevelSelected}
          />
        )}

        {currentPage === "conditions" && (
          <ConditionsContainer
            onConditionsSelect={handleConditionsSelect}
            onBack={handleBack}
          />
        )}
        {currentPage === "userData" && (
          <UserData onSubmit={handleUserDataSubmit} onBack={handleBack} />
        )}
        {currentPage === "deliveryMethod" && (
          <DeliveryMethod
            onSubmit={handleDeliveryMethodSubmit}
            onBack={handleBack}
          />
        )}
        {currentPage === "offerByDays" && (
          <OfferByDays
            model={selectedModel}
            selectedStorage={selectedStorage}
            grade={grade}
            batteryLevel={batteryLevelSelected}
            onOfferSelect={handleOfferSelect}
            onBack={handleBack}
          />
        )}
        {currentPage === "newSummary" && (
          <NewSummary
            selectedBrand={selectedBrand}
            selectedModel={selectedModel}
            selectedStorage={selectedStorage}
            buttonsCondition={buttonsCondition}
            exteriorCondition={exteriorCondition}
            screenCondition={screenCondition}
            grade={grade}
            deliveryMethod={deliveryMethod}
            UserData={userData}
            scheduleInfo={scheduleInfo}
            sendInfoData={sendInfoData}
            selectedOffer={selectedOffer}
            batteryLevel={batteryLevelSelected}
          />
        )}
        {currentPage === "offerUnsuccess" && (
          <OfferUnsuccess onBack={handleBack} />
        )}
        {currentPage === "sendInfo" && (
          <SendInfo onContinue={handleSendInfoContinue} onBack={handleBack} />
        )}
        {currentPage === "scheduleVisit" && (
          <ScheduleVisit
            info={scheduleInfo}
            onSchedule={handleSchedule}
            sendInfoData={sendInfoData}
            userData={userData}
            deliveryMethod={deliveryMethod}
            onBack={handleBack}
          />
        )}
      </div>
    </div>
  );
}

export default InitialPage;
